// extracted by mini-css-extract-plugin
export var card = "_49-0";
export var content = "_49-1";
export var contentLoading = "_49-2";